import React, { useEffect, useState, useMemo, useContext } from "react";
import { Container, Col, Row, Accordion, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
// import "../Products/Pagination";
import Pagination from "../../AllEquities/Pagination/Pagination";
import "../../AllEquities/Pagination/pagination.css";
import "../../AllEquities/AllEquitiesFilter/AllEquitiesFilter.css"
// import Pagination from '../Products/Pagination';
import URLstateContext from "../../../provider/CommonContext";
// import MultiRangeSlider from ".././Products/Slider/MultirangeSlider"

//import Pagination from '../Pagination';
import { RangeSlider, InputGroup, InputNumber } from 'rsuite';
import "rsuite/dist/rsuite.min.css";

let PageSize = 6;
let allsectcode = [];
let all_indexcoode = [];
let allindexcode = [];
var parametrs = [];
let idnxarr = [];
var valuesector = '';
var valuesector1 = '';
var c_allcompdata = null;
let filtered2 = null;
var objFilters = { 'Sector': [], 'Index': [], 'MCAP': [], 'PrevClose' :[] };
var t_setSchemesdata = null;
var arr = [];
// let filtered2_New = null;
var paramexchange = '';



function AllEquitiesFilter() {

    const { BaseURL } = useContext(URLstateContext);
    const [allcompdata, setallcompdata] = useState([]);
    const [data, setdata] = useState([]);
    const [isLoaded, setisLoaded] = useState(false);
    const [filterdata, setFilterdata] = useState([])
    const [checked, setChecked] = useState([]);
    const [checkedSchemes, setSchemesdata] = useState([]);
    const [chksectorlist, setChecksector] = useState([]);
    const [searchParam] = useState(["capital", "name", "numericCode"]);
    const [filterParam, setFilterParam] = useState(["All"]);
    const [is_hide_chk, set_is_hide_chk] = useState("");
    const [compcount, setcompcount] = useState("");
    const [chkindexlist, setCheckindex] = useState([]);
    const [exchange, setexchange] = useState("NSE");
    const [value, setValue] = useState([100000, 1500000]);
    const [valueClose, setValueClose] = useState([15000, 25000]);
    const [q, setQ] = useState("");
    const [searchTerm] = useState(["SectorName"]);
    const [searchInput, setSearchInput] = useState([]);
    const [searchtext, setSearchtext] = useState([]);

    var filtered2;
    var t_setSearchtext = null;

    let navigate = useNavigate();

    const handleCheck = (event, param) => {
        // alert(event.target.checked + " || " + param['type']);
        // alert("param['Value'] : " + param['Value']);
        valuesector = param;
        // console.log(valuesector)

        if (param['type'] == "Sector"   && event.target.checked == true ) {
            // valuesector = param;
            objFilters[param['type']].push(param['Value'])
            // allsectcode.push(param['sector']);
        } else if (param['type'] == "Sector"  &&  event.target.checked == false) {
            for (var i = 0; i < objFilters['Sector'].length; i++) {
                if (objFilters['Sector'][i] == param['Value']) {
                    //objFilters['Sector'].splice(param['Value']);
                    objFilters['Sector'].splice(i, 1);
                }
                
            }
        }
        else if (param['type'] == "Index"  &&  event.target.checked == true ) {
            objFilters[param['type']].push(param['Value'])
            //console.log("objFilters[param['type']].push(param['Value']) : " + objFilters[param['type']] + " " + (param['Value']))
            //console.log("objFilters : " + JSON.stringify(objFilters));
            // all_indexcoode.push(param['index']);
        } else if (param['type'] == "Index"  && event.target.checked == false ) {
            for (var i = 0; i < objFilters['Index'].length; i++) {
                if (objFilters['Index'][i] == param['Value']) {
                    objFilters['Index'].splice(i, 1);
                }

            }
        }
        else if (param['type'] == "MCAP") {
            for (var value1 of Object.values(value))
                objFilters[param['type']].push(value1)
        }
        else if (param['type'] == "PrevClose") {
            for (var value2 of Object.values(valueClose))
                objFilters[param['type']].push(value2)
        }

        //const filtered2 = t_setSchemesdata.filter(obj => {

        //    return objFilters['Sector'].includes(obj.Sect_code)  ||              
        //     filterTwoLists(objFilters['Index'], (obj.indexcode == null || obj.indexcode == "") ? null : (obj.indexcode).split(","))

        //});

        var filtered2;
        if (objFilters['Sector'].length > 0) {
            filtered2 = t_setSchemesdata.filter(obj => {
                return objFilters['Sector'].includes(obj.Sect_code);
            })
        }
        else {
            filtered2 = t_setSchemesdata;
        }
        if (objFilters['Index'].length > 0) {
            filtered2 = filtered2.filter(obj => {
                return filterTwoLists(objFilters['Index'], (obj.indexcode == null || obj.indexcode == "") ? null : (obj.indexcode).split(","));
            })
        }

        if (objFilters['MCAP'].length > 0) {
            filtered2 = t_setSchemesdata.filter(obj => {  
                return objFilters.MCAP[0] <= obj.MCAP && objFilters.MCAP[1] >= obj.MCAP
            })

            objFilters[param['type']] = []
        }

        if (objFilters['PrevClose'].length > 0) {
            filtered2 = t_setSchemesdata.filter(obj => {  
                return objFilters.PrevClose[0] <= obj.PrevClose && objFilters.PrevClose[1] >= obj.PrevClose
            })

            objFilters[param['type']] = []
        }

        // console.log("objFilters : " + JSON.stringify(objFilters));
        // console.log("filtered2  : " + JSON.stringify(filtered2));

        if ((objFilters['Sector'].length == 0 || objFilters['Index'].length == 0 || objFilters['MCAP'].length == 0 || objFilters['PrevClose'].length == 0 ) && filtered2.length == 0) {
            setSchemesdata(allcompdata);
            setcompcount(allcompdata.length);
        }
        else {

            setSchemesdata(filtered2);
            setcompcount(filtered2.length);
        }

    };


//search text

 function search(items) {

    var t_searched = items.filter((item) => {
        // console.log(item,"item");
         return searchTerm.some((newItem) => {
            
            // console.log(newItem,"newItem");
             return (
                 item[newItem]
                     .toString()
                     .toLowerCase()
                     .startsWith(q.toLowerCase())
             );
         });
     });
    //  console.log("t_searched: "+ JSON.stringify(t_searched))


     return items.filter((item) => {
        // console.log(item,"item");
         return searchTerm.some((newItem) => {
            // console.log(newItem,"newItem");
             return (
                 item[newItem]
                     .toString()
                     .toLowerCase()
                     .startsWith(q.toLowerCase())
                    //  .indexOf(q.toLowerCase()) > -1
             );
         });
     });

 }


    function filterTwoLists(arr1, arr2) {
        if (arr2 == null || arr2 == "")
            return false
        var tmparr = arr1.filter(x => arr2.map(function (item) { return parseInt(item, 10) }).includes(x));
        if (tmparr.length > 0)
            return true
        else
            return false
    }
    useEffect(() => {
        const getSectorListUrl = BaseURL + "SectorList";
        fetch(`${getSectorListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;

                setChecksector(myrepo);
                setSearchtext(myrepo);
                t_setSearchtext = myrepo;
                // console.log(t_setSearchtext,"t_setSearchtext")
                // console.log(myrepo);
                // console.log(myrepo);
            })
            .catch((error) => {
              //  console.log("not found the api");
            });

    }, []);

    //index code
    //allcompany data bind starts
    function getdata(parametrs) {
        if (parametrs.Sector.length == 0) {

            parametrs.Sector = '-'
        }
        else if (parametrs.Indexcode.length == 0) { parametrs.Indexcode = '-' }

        const getpricedataUrl = BaseURL + "StockScreenerBasedonPriceData";
       // console.log((`${getpricedataUrl}/${parametrs.Exchange}/${parametrs.Sector}/${parametrs.Indexcode}/${parametrs.mcapfrom}/${parametrs.mcapto}/${parametrs.pricefrom}/${parametrs.pricefrom}/${parametrs.top}`));
        fetch(`${getpricedataUrl}/${parametrs.Exchange}/${parametrs.Sector}/${parametrs.Indexcode}/${parametrs.mcapfrom}/${parametrs.mcapto}/${parametrs.pricefrom}/${parametrs.pricefrom}/${parametrs.top}`)
            .then((response) => response.json())
            .then((data) => {
                // const myrepo = data.data;
                // setChecksector(myrepo);
                // console.log(myrepo);
                // console.log("alldata : " , data.data);
                const alldata = data.data;
                setSchemesdata(alldata);
                setallcompdata(alldata);
                //console.log("allcompdata+allcompdata : " + allcompdata);
                setcompcount(alldata.length);
                c_allcompdata = alldata//JSON.parse(JSON.stringify(allcompdata));
                t_setSchemesdata = alldata;

                // console.log("alldata : " + JSON.stringify(alldata));
                setisLoaded(true);
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }
    //allcompany data bind ends
    const companyClick = (event, param) => {
       // { alert("companyClick call" + param.co_code + " : " + param.CompanyName); }

        navigate("/CompanySnapshot/" + 'nse' + "/" + param.co_code + "/" + param.CompanyName, {
            //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
        });
    }
    const exchangeClick = (event, param) => {
        setexchange(param);
        if (param == 'BSE') {
            exchangedata('BSE');
            var parametrs = {
                Exchange: 'BSE',
                Sector: '-',
                Indexcode: '-',
                mcapfrom: '-',
                mcapto: '-',
                pricefrom: '-',
                price: '-',
                top: '-'
            }
            getdata(parametrs)
        }
        else if (param == 'NSE') {
            exchangedata('NSE');
            var parametrs = {
                Exchange: 'NSE',
                Sector: '-',
                Indexcode: '-',
                mcapfrom: '-',
                mcapto: '-',
                pricefrom: '-',
                price: '-',
                top: '-'
            }
            getdata(parametrs)
        }
    }

    function exchangedata(paramexchange) {
        //alert(paramexchange);
        const getindexListonclickUrl = BaseURL + "Indicess";
        fetch(`${getindexListonclickUrl}/${paramexchange}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                //setCheckedind(myindex.data);
                setCheckindex(myrepo);
                // alert("getindexList onclic kUrl : " + JSON.stringify(myrepo));
            })
            .catch((error) => {
               // console.log("not found the api");
            });
    }
    useEffect(() => {
        const getSectorListUrl = BaseURL + "Indicess/nse";
        fetch(`${getSectorListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                //setCheckedind(myindex.data);
                setCheckindex(myrepo);
                // console.log(myrepo);
            })
            .catch((error) => {
              //  console.log("not found the api");
            });
    }, []);

    //index code
    var isChecked = (item) =>
        checked.includes(item) ? "checked-item" : "not-checked-item";

    const [currentPage, setCurrentPage] = useState(1);
    const currentTableData = useMemo(() => {

        if (checkedSchemes.length > 0) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;

            return checkedSchemes.slice(firstPageIndex, lastPageIndex);
        }

    }, [currentPage, checkedSchemes]);
    //alert("allcompdata : " + allcompdata);

    useEffect(() => {
        var parametrs = {
            Exchange: 'NSE',
            Sector: '-',
            Indexcode: '-',
            mcapfrom: '-',
            mcapto: '-',
            pricefrom: '-',
            price: '-',
            top: '-'
        }
        getdata(parametrs)

    }, []);
    // const handleInput = (e) => {
    //   //alert(JSON.stringify(e));
    //   console.log("e:" + JSON.stringify(e));
    // };

    // const handleindexCheck = (event, param1) => {
    //   console.log(param1);
    //   if (event.target.checked) {
    //     allindexcode.push(param1);
    //   }
    //   console.log(allindexcode);
    //   var updatedList = [...checkedind];


    //   //set data starts

    //   // var parametrs = {
    //   //     Exchange: 'NSE',
    //   //     Sector: allsectcode,
    //   //     Indexcode: allindexcode,
    //   //     mcapfrom: 50000,
    //   //     mcapto: 170000,
    //   //     pricefrom: '-',
    //   //     price: '-',
    //   //     top: '-'
    //   // }
    //   // getdata(parametrs)
    // };
    // var isChecked = (item) =>
    //   checkedind.includes(item) ? "checked-item" : "not-checked-item";
    // const value_handler = (e) => {

    //   setQ(e.target.value)
    // }

    return (
        <>
            <section className="filter-equities">
                <Container>
                    <Row>
                        <Col md={4}>
                            <div className="filter-block">
                                <div>
                                    <h4>
                                        <span>Filters</span>
                                        <button type="button" className={exchange === "NSE" ? "activeEquity" : "inactiveEquity"} onClick={event => exchangeClick(event, 'NSE')} id="_NSE">NSE</button>
                                        <button type="button" className={exchange === "BSE" ? "activeEquity" : "inactiveEquity"} onClick={event => exchangeClick(event, 'BSE')} id="_BSE">BSE</button>
                                    </h4>
                                </div>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Sectors</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Type to search"

                                                    onChange={(e) => setQ(e.target.value)}

                                                />
                                                {/* ))}  */}
                                            </Form.Group>


                                            {/* checkbox bind starts */}
                                            <Form.Group className="mb-3" id="select_sectorlistcontainer smallfontsize" style={{ "max-height": "150px", "overflow-y": "scroll", "font-size": "13px;" }}>

                                                {search(chksectorlist).map((item, index) => (
                                                    <div key={index}>
                                                        {/* <input
                                                            value={item.sect_code}
                                                            type="checkbox"
                                                            onChange={handleCheck}
                                                            className={is_hide_chk}
                                                        /> */}
                                                        <input className="inputcheckbox" value={item.sect_code} id="sec_code" type="checkbox"
                                                            onChange={event => handleCheck(event, { "type": "Sector", "Value": item.sect_code })}
                                                            style={{ "margin-left": "0px", "margin-right": "10px" }} />
                                                        <span className="smallfontsize">{item.SectorName}</span>
                                                    </div>
                                                ))}
                                            </Form.Group>

                                            {/* checkbox bind ends */}

                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Index</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="list-container"  >
                                                {chkindexlist.map((itemindex, index) => (
                                                    <div key={itemindex.IndexName}>
                                                        <input value={itemindex.index_code} id="ind_code" type="checkbox" onChange={event => handleCheck(event, { "type": "Index", "Value": itemindex.index_code })} style={{ "margin-left": "0px", "margin-right": "10px" }} />

                                                        <span className="smallfontsize">{itemindex.IndexName}</span>
                                                        {/* <span className={isChecked(itemindex.IndexName)}>{itemindex.IndexName}</span> */}
                                                    </div>
                                                ))}
                                            </div>

                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Market Cap (Cr)</Accordion.Header>
                                        <Accordion.Body>
                                            <RangeSlider
                                                progress
                                                style={{ marginTop: 16, marginBottom: 30 }}
                                                marks
                                                step={1}
                                                min={0}
                                                max={2000000}
                                                value={value}
                                                onChange={sl_value => {
                                                    setValue(sl_value);
                                                    handleCheck(sl_value, { "type": "MCAP", "Value": sl_value })
                                                }}

                                            />
                                            <Row>
                                                <InputGroup>
                                                    <Form.Group as={Col} col="6">
                                                        <InputNumber
                                                            required type="text"
                                                            placeholder="0"
                                                            min={0}
                                                            max={2000000}
                                                            value={value[0]}
                                                            onChange={nextValue => {
                                                                const [start, end] = value;
                                                                if (nextValue > end) {
                                                                    return;
                                                                }
                                                                setValue([nextValue, end]);
                                                            }}
                                                        />
                                                    </Form.Group> <span className="equityTo">to</span>
                                                    <Form.Group as={Col} col="6">
                                                        <InputNumber
                                                            required
                                                            type="text"
                                                            placeholder="10000"
                                                            min={0}
                                                            max={2000000}
                                                            value={value[1]}
                                                            onChange={nextValue => {
                                                                const [start, end] = value;
                                                                if (start > nextValue) {
                                                                    return;
                                                                }
                                                                setValue([start, nextValue]);
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </InputGroup>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Close Price </Accordion.Header>
                                        <Accordion.Body>
                                            <RangeSlider
                                                progress
                                                style={{ marginTop: 16, marginBottom: 30 }}
                                                marks
                                                step={1}
                                                min={0}
                                                max={100000}
                                                value={valueClose}
                                                onChange={slClose_value => {
                                                    setValueClose(slClose_value);
                                                    handleCheck(slClose_value, { "type": "PrevClose", "Value": slClose_value })
                                                }}

                                            />
                                            <Row>
                                                <InputGroup>
                                                    <Form.Group as={Col} col="6">
                                                        <InputNumber
                                                            required type="text"
                                                            placeholder="0"
                                                            min={0}
                                                            max={100000}
                                                            value={valueClose[0]}
                                                            onChange={nextValue => {
                                                                const [start, end] = value;
                                                                if (nextValue > end) {
                                                                    return;
                                                                }
                                                                setValueClose([nextValue, end]);
                                                            }}
                                                        />
                                                    </Form.Group> <span className="equityTo">to</span>
                                                    <Form.Group as={Col} col="6">
                                                        <InputNumber
                                                            required
                                                            type="text"
                                                            placeholder="10000"
                                                            min={0}
                                                            max={100000}
                                                            value={valueClose[1]}
                                                            onChange={nextValue => {
                                                                const [start, end] = value;
                                                                if (start > nextValue) {
                                                                    return;
                                                                }
                                                                setValueClose([start, nextValue]);
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </InputGroup>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="products-card">
                                <h5>Search Result {compcount} Stocks</h5>

                                <div className="product-table">
                                    <div className="header-main">
                                        <h6 className="text-left">Company</h6>
                                        <h6 className="text-right">Market Price</h6>
                                        <h6 className="text-right">Close Price</h6>
                                        <h6 className="text-right">Market Cap</h6>
                                    </div>
                                    {currentTableData != null ? (
                                        currentTableData.map((getallcompdata, indexalldata) => {
                                            return (

                                                <div className="body-row" key={indexalldata}>
                                                    <p className="text-left" onClick={event => companyClick(event, { a: getallcompdata.co_code, b: getallcompdata.CompanyName })}>{getallcompdata.CompanyName} </p>

                                                    <p className="text-right" >₹{getallcompdata.CurrentPrice}
                                                        <span className="color-red" >({getallcompdata.PerChange.toFixed(2)})</span>
                                                        <span className="color-red">({getallcompdata.PriceDiff.toFixed(2)}%)</span>
                                                    </p>
                                                    <p className="text-right" >₹{getallcompdata.PrevClose}</p>
                                                    <p className="text-right" >₹{getallcompdata.MCAP}</p>
                                                </div>
                                            );
                                        })
                                    ) : (<div>No Data..</div>
                                    )}
                                </div>
                                {isLoaded ? (
                                    <Pagination
                                        className="pagination-bar"
                                        currentPage={currentPage}
                                        totalCount={checkedSchemes.length}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    />
                                ) : (
                                    <div>Nothing to display</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>

    );

}

export default AllEquitiesFilter;
